<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="small">
        <div class="content-name">
          <h2 class="dp-ib">장애처리관리</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="info" icon="el-icon-close" @click="cancel">취소</el-button>
            <el-button type="danger" icon="el-icon-delete" @click="deleteRow">삭제</el-button>
            <el-button type="primary" icon="el-icon-document-add" @click="save">저장</el-button>
            <el-button type="warning" icon="el-icon-document-copy" @click="saveIdx">순서저장</el-button>
          </el-form-item>
        </div>
      </el-form>
      <!-- 테이블 -->
      <div class="talbe-contain" style="display: flex;">
        <div class="table-area" style="margin-right: 50px; width: 30%;">
          <div class="table-b">
            <ag-grid-vue
                ref="gridMain"
                :style="gridStyle"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                :headerHeight="0"
                :rowModelType="rowModelType"
                :treeData="true"
                :isServerSideGroup="isServerSideGroup"
                :isServerSideGroupOpenByDefault="isServerSideGroupOpenByDefault"
                :getServerSideGroupKey="getServerSideGroupKey"
                :autoGroupColumnDef="autoGroupColumnDef"
                :animateRows="true"
                :rowData="data"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :gridOptions="gridOptions"
                :suppressRowClickSelection="false"
                @grid-ready="onReadyMain"
                @cell-clicked="onCellClickedMain"
            />
          </div>
        </div>
        <div class="table-area" style="width: 70%;">
          <div class="table-b">
            <ag-grid-vue
                ref="gridSub"
                style="width: 100%; height: 42vh; min-height: 25px;"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                :columnDefs="columnDefsSub"
                :defaultColDef="defaultColDefSub"
                :frameworkComponents="frameworkComponents"
                :rowData="subData"
                :gridOptions="gridOptionsSub"
                :suppressRowClickSelection="false"
                :statusBar="statusBar"
                @grid-ready="onReadySub"
                @cell-clicked="onCellClickedsub"
            />
          </div>
          <RepairInfo ref="RepairInfo"  :catDetail="catDetail" :parentNm="parentNm" :catLvl="form.catLvl"/>
        </div>
      </div> <!-- table contain -->
    </div>
  </div>

</template>
<script>
import _ from "lodash";

import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer'
import common from '@/mixin/common';
import RepairInfo from '@/components/InfoManage/RepairInfo.vue';

/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [common],
  name: "codeMng",
  components: {RepairInfo},
  data() {
    return {
      title: "",
      deleteid: "",
      deleteList: [],
      rowData: [],
      onReadyParams:[],
      parentNm: "",
      form: {
        catKey: "",
        catNm: "",
        catId: "",
        parentId: "",
        topKey: "",
        catIdx: "",
        description: "",
        catValue1: "",
        catValue2: "",
        catValue3: "",
        catValue4: "",
        catValue5: "",
      },
      defForm: {
        catKey: "",
        catNm: "",
        catNm2: "",
        catNm3: "",
        catNm4: "",
        catNm5: "",
        catId: "",
        parentId: "",
        topKey: "",
        catIdx: "",
        description: "",
        catValue1: "",
        catValue2: "",
        catValue3: "",
        catValue4: "",
        catValue5: "",
        catLvl : 1,
      },
      data: [],
      subData: [],
      gridOptions: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
        rowModelType: 'serverSide',
      },
      gridOptionsSub: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      catDetail: [],
      gridApi: null,
      columnApi: null,
      columnDefs: [],
      gridApiSub: null,
      columnApiSub: null,
      columnDefsSub: [],
      frameworkComponents: null,
      autoGroupColumnDef: null,
      rowModelType: null,
      isServerSideGroupOpenByDefault: null,
      isServerSideGroup: null,
      getServerSideGroupKey: null,
      selectId : "",
      gridStyle : 'padding-top: 0px; width: 100%;height: 83.5vh; min-height:100px;',
    };
  },
  methods: {
    //메인그리드 Ready
    onReadyMain(params) {
      //메인그리드 api 정의
      this.onReadyParams = params;
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.sizeColumnsToFit();

      const updateData = (data) => {
        var fakeServer = this.createFakeServer(data);
        var datasource = this.createServerSideDatasource(fakeServer);
        params.api.setServerSideDatasource(datasource);
        return data;
      };
      this.$http.post(_url("/api/tree/obstacleTreatMng/list"), {
        companyId: this.$store.state.loginInfo.compCd,
        processTime : ""
      }).then(response => {
        this.data = updateData(response.data);
      });
    },
    //서브그리드 Ready
    onReadySub(params) {
      //서브그리드 api 정의
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;

      this.gridApiSub.sizeColumnsToFit();
      this.autoSizeAll(this.columnApiSub);
    },
    autoSizeAll(columnApi) {
      const allColumnIds = [];
      columnApi.columnController.gridColumns.forEach((column) => {
        allColumnIds.push(column.getId());
      });
      columnApi.columnController.autoSizeColumns(allColumnIds, false);
    },
    //그리드컬럼 정의
    createColumnDefs() {
      const vm = this

      this.autoGroupColumnDef = {
        field: 'menu_nm',
        cellRendererParams: {
          innerRenderer: (params) => {
            return params.data.menu_nm;
          },
        },
      };
      this.rowModelType = 'serverSide';
      this.isServerSideGroupOpenByDefault = (params) => {
        // open first two levels by default
        return params.rowNode.level < 1;
      };
      this.isServerSideGroup = (dataItem) => {
        // indicate if node is a group
        //console.log(dataItem);
        return dataItem.group;
      };
      this.getServerSideGroupKey = (dataItem) => {
        // specify which group key to use
        return dataItem.menu_id;
      };

      this.columnDefsSub = [
        {
          headerName: '선택'
          , field:'regYn'
          , width : 15
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "1"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: "0"  //false값 지정 defalut-"N" ex) "N", false, "0"
          },
        },
        {headerName:'제품군', field:'catNm2', headerClass: 'require-column', width:80, editable:false},
        {headerName:'증상구분', field:'catNm3', headerClass: 'require-column', width:50, editable:false},
        {headerName:'고장증상', field:'catNm4', width:50, editable:false},
        {headerName:'고장부위', field:'catNm5', width:50, editable:false},
        {headerName:'처리유형', field:'catNm6', width:50, editable:false},
        {headerName:'VALUE1', field:'catValue1', width:50, editable:false},
        {headerName:'VALUE2', field:'catValue2', width:50, editable:false},
        {headerName:'VALUE3', field:'catValue3', width:50, editable:false},
        {headerName:'VALUE4', field:'catValue4', width:50, editable:false},
        {headerName:'VALUE5', field:'catValue5', width:50, editable:false},
        // {
        //   headerName: '사용'
        //   , field:'useYn'
        //   , width : 15
        //   , editable: false
        //   , cellRenderer: 'checkboxRenderer'
        //   , cellRendererParams: {
        //     trueValue: "Y"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
        //     , falseValue: "N"  //false값 지정 defalut-"N" ex) "N", false, "0"
        //   },
        // },
        {headerName:'순서', field:'catIdx', width:30, editable:true, cellStyle:{ textAlign:'right'}},
        {headerName:'', field:'catId', hide : true},];
    },
    //Main 그리드 SelctionChange 발생
    onCellClickedMain(params) {
      const voRow = params.data //선택된 Row
      this.rowData = params.data;
      this.catDetail = this.defForm;
      this.parentNm = voRow.menu_nm;
      this.form.catLvl = voRow.menu_lvl;
      this.$store.commit('loading')

      this.$http
          .post("/api/repairMng/detail",
              {
            companyId: this.$store.state.loginInfo.compCd,
            parentId: voRow.menu_id,
            sortType : true,
            page : 1,
            totalPage : 9999,
            totalCount : 9999,
            curPage : 0,
            standDt : "",
            catNm4  : "",
            catNm5  : "",
            processTime : ""
          })
          .then(response => {
            this.subData = response.data
            this.selectId = voRow.menu_id;
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    onCellClickedsub(params) {
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;
      const voRow = params.data //선택된 Row
      this.$http
          .post("/api/codeMng/detail/sub", {
            companyId: this.$store.state.loginInfo.compCd,
            catId: voRow.catId,
            processTime : ""
          })
          .then(response => {
            if(response.data[0]){
              this.catDetail = response.data[0];
            }
          }).finally(() => {
      });
    },
    goOpen() {
      const voRow = this.rowData;

      // detail 재실행
      this.$store.commit('loading')
      this.$http
          .post("/api/repairMng/detail",
              {
                companyId: this.$store.state.loginInfo.compCd,
                parentId: voRow.menu_id,
                sortType : true,
                page : 1,
                totalPage : 9999,
                totalCount : 9999,
                curPage : 0,
                standDt : "",
                catNm4  : "",
                catNm5  : "",
                processTime : ""
              })
          .then(response => {
            this.subData = response.data
            this.selectId = voRow[0].menu_id;
          }).finally(() => {
        this.$store.commit('finish')
      });

    },
    save() {
      const catInfo = JSON.parse(JSON.stringify(this.$refs.RepairInfo.form));
      if(!this.gridRequireCheck([this.$refs.gridMain, this.$refs.gridSub ])) return;

      // 비어있다면 생성 , 비어있지 않다면 수정
      if(catInfo.catId == ""){
        let maxIdx = 0;

        for (var i = 0; this.subData.length > i ; i++){
          if(this.subData[i].catIdx > maxIdx) maxIdx = this.subData[i].catIdx;
        }


        //상세코드 확인
        if(catInfo.catNm == ""){
          this.$swal({type: 'warning', text: '분류명은 필수 입력 사항입니다.'});
          return false;
        }


        //저장 시작

        this.$http
            .put('/api/codeMng/save/tree',{
              companyId: this.$store.state.loginInfo.compCd,
              parentId: this.selectId == 0 ? 140 : this.selectId,
              catIdx: maxIdx+1,
              catNm: catInfo.catNm,
              catValue1: catInfo.catValue1,
              catValue2: catInfo.catValue2,
              catValue3: catInfo.catValue3,
              catValue4: catInfo.catValue4,
              catValue5: catInfo.catValue5,
              useYn: "Y",
              description: catInfo.description,
              creatorId: this.$store.state.loginInfo.id, // 추후 로그인 id 넣을것
              processTime: "",
              catId: "0",
            })
            .then(response => {
              this.$swal({ type: 'success', text: '저장되었습니다.' });
              this.cancel();
              this.onReadyMain(this.onReadyParams);
              this.goOpen();
            })
            .catch(({ message }) => {
              if (message === "Request failed with status code 500") {
                this.$swal({ type: "error", text: "오류가 발생했습니다." });
              }
            }).finally(() => {
          this.$store.commit('finish')
        });
      }else{
        //수정 시작

        this.$http
            .put('/api/codeMng/update',{
              companyId: this.$store.state.loginInfo.compCd,
              catId: catInfo.catId,
              catIdx: catInfo.catIdx,
              catNm: catInfo.catNm,
              catKey: catInfo.catKey,
              catValue1: catInfo.catValue1,
              catValue2: catInfo.catValue2,
              catValue3: catInfo.catValue3,
              catValue4: catInfo.catValue4,
              catValue5: catInfo.catValue5,
              useYn: "Y",
              description: catInfo.description,
              updatorId: this.$store.state.loginInfo.id, // 추후 로그인 id 넣을것
              processTime: "",
            })
            .then(response => {
              this.$swal({ type: 'success', text: '수정되었습니다.' });
              this.cancel();
              this.onReadyMain(this.onReadyParams);
              this.goOpen();
            })
            .catch(({ message }) => {
              if (message === "Request failed with status code 500") {
                this.$swal({ type: "error", text: "오류가 발생했습니다." });
              }
            }).finally(() => {
          this.$store.commit('finish')
        });
      }


    },
    saveIdx() {
      let subData = this.$refs.gridSub.rowData;
      let submitList = [];

      for(var i=0; subData.length > i; i++){
        submitList.push({
          companyId: this.$store.state.loginInfo.compCd,
          catId: subData[i].catId,
          catIdx: subData[i].catIdx,
          updatorId: this.$store.state.loginInfo.id,
          processTime: ""
        });
      }

      this.$http.put('/api/codeMng/update/idx',submitList)
          .then(response => {
            this.$swal({ type: 'success', text: '수정되었습니다.' });
            this.goOpen();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          }).finally(() => {
        this.$store.commit('finish')
      });
    },

    deleteRow() {

      const grid = this.$refs.gridSub

      const chkDatas = grid.rowData.filter((x,i) => {
        return x.regYn === "1"
      })

      if(chkDatas.length == 0)this.$swal({ type: 'error', text: '삭제할 분류를 체크하세요.' });

      for (var i = 0; chkDatas.length > i ; i++){
        let catId = parseInt(chkDatas[i].catId);
        let updatorId = 10001; // 추후 로그인 id 받아서 처리
        let compCd =  this.$store.state.loginInfo.compCd;
        this.$http.delete(_url("/api/codeMng/delete/"+ (compCd) +"/"+ (catId) + "/" + (updatorId) ), {
          process_time : new Date()
        }).then(response => {
          this.$swal({ type: 'success', text: '삭제 되었습니다.' });
          this.goOpen();
        });
      }


    },
    addRow() {
      this.data.push({
        groupCd: "",
        groupNm: "",
        useYn: "Y",
        groupDesc: "",
        compCd: this.$store.state.loginInfo.compCd,
      });
    },
    deleteRowd() {
      try{

        const row = this.gridApiSub.getSelectedNodes()

        if(row.length < 1)
          throw '선택된 행이 없습니다.'

        let index = row[0].rowIndex
        this.subData.splice(index, 1)

      }catch (e) {
        this.$swal({
          type: 'warning',
          text: e
        })
      }
    },
    addRowd() {
      try{

        const row = this.gridApi.getSelectedNodes()

        if(row.length < 1)
          throw '그룹코드가 선택되지 않았습니다.'

        const idx = row[0].rowIndex

        this.subData.push({
          detailCd: "",
          detailNm: "",
          useYn: "Y",
          orderSeq: "",
          remark1: "",
          remark2: "",
          remark3: "",
          remark4: "",
          remark5: "",
          detailDesc: "",
          parent_id: this.data[0].inner_menu[idx-1].parent_id,
          compCd: this.$store.state.loginInfo.compCd,
        });
      }catch (e) {
        this.$swal({
          type: 'warning',
          text: e
        })
      }
    },
    cancel(){
      // CatInfo 초기화
      this.$refs.RepairInfo.form = _.clone(this.defForm);
    },
    createFakeServer(ServerData) {
      const Server = {
        data: ServerData,
        getData: function (request) {
          function extractRowsFromData(groupKeys, data) {
            if (groupKeys.length === 0) {
              return data.map(function (d) {
                var has_inner_menu = d.inner_menu.length == 0? false : true;
                return {
                  group:  has_inner_menu,
                  menu_id: d.menu_id,
                  menu_nm: d.menu_nm,
                  menu_lvl: d.menu_lvl
                };
              });
            }
            var key = groupKeys[0];
            for (var i = 0; i < data.length; i++) {
              if (data[i].menu_id === key) {
                return extractRowsFromData(
                    groupKeys.slice(1),
                    data[i].inner_menu.slice()
                );
              }
            }
          }
          return extractRowsFromData(request.groupKeys, this.data);
        },
      };
      return Server;
    },
    createServerSideDatasource(fakeServer) {
      const dataSource = {
        getRows: (params) => {
          //console.log('ServerSideDatasource.getRows: params = ', params);

          var allRows = fakeServer.getData(params.request);
          var request = params.request;
          var doingInfinite = request.startRow != null && request.endRow != null;
          var result = doingInfinite
              ? {
                rowData: allRows.slice(request.startRow, request.endRow),
                rowCount: allRows.length,
              }
              : { rowData: allRows };
          setTimeout(function () {
            params.success(result);
          }, 200);
        },
      };
      return dataSource;
    }
  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
    };

  },
  mounted() {
    //this.goOpen();
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
};

</script>